import RocketCrash from "@Images/NewUI/RocketCrashnew.png";
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Kycnotdone = (props) => {
  const navigate = useNavigate();
  const handleUpdateKyc = () => {
   navigate("/manual_verify?keyfrom=kycchange"); 
  };

  return (
   <>
   
   
   <div className='container'>
  
   <div className="wrapper-content kyc_margin">
                    <div className="kyccard-height px-4 pb-3 pt-1 w-100 text-center mx-auto  rounded-40 ">
                      <div className="d-flex flex-column justify-content-between">
                        <div className="pt-4 pb-5">
                        <img
                            src={RocketCrash}
                            alt="loadImg"
                            className="pop_kyc"
                        />
                        <h1 className='kycVerificationfont'>Sorry !</h1>
                        <p className='kycparagraph'>It seems your KYC hasn't been verified.</p>
                        </div>
                      </div>
                    </div>
                    <div className="text-center pt-4 setmoney_div">
                        <div
                        className="GetNowBtnrepayvd"
                        onClick={handleUpdateKyc}
                        >
                        Update KYC
                        </div>
                      </div>
                    
    </div>
   </div>
   </>
  )
}

export default  Kycnotdone